import type { AxiosResponse } from "axios";
import Photo from "@/api/photo/models";
import type { PaginationResponse } from "@/interfaces/api";
import { api } from "@/services/api";
import { crud } from "../crud";

const photoApi = crud<Photo>("photo", "Photo");
const BOOK_PAGE_SIZE = 6;

export const photoCrud = {
  ...photoApi,
  getBookPhotos: (talentId: string, page: number, limit = BOOK_PAGE_SIZE): Promise<PaginationResponse<Photo>> =>
    api.get(`/photo/${talentId}`, { params: { page, limit } }).then((response) => response.data),
  downloadBookPhoto: (talentId: string, photoId: string): Promise<AxiosResponse<Blob>> =>
    api.get(`/photo/${talentId}/${photoId}/download`, { responseType: "blob" }),
};
